import React from "react";
import PersonIcon from "@material-ui/icons/Person";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import LocationCityIcon from "@material-ui/icons/LocationCity";
import PermIdentityIcon from "@material-ui/icons/PermIdentity";
import { Grid, Typography } from "@material-ui/core";
import HttpService from "../services/httpService";
import AadhaarReveal from "../components/AadhaarReveal";
import { InfoItem, DetailItem } from "./approvalTypesRegistry";

export const ONBOARDING_APPROVAL_TYPES = [
    {
        key: "channelPartner",
        label: "Channel Partner",
        icon: <PersonIcon fontSize="small" />,
        fetchApprovals: () => HttpService.getAllChannelPartners({ status: "pending_verification" }),
        fetchHistory: () => HttpService.getAllChannelPartners(),
        approveAction: (id, data) => HttpService.actOnChannelPartnerOnboarding(id, data),
        rowKey: (row) => row._id,
        approveId: (row) => row._id,
        title: (row) => row?.full_name || "Channel Partner",
        renderCardBody: (row) => (
            <Grid container spacing={2}>
                {row?.cp_code && (
                    <InfoItem
                        icon={<PermIdentityIcon fontSize="small" color="action" />}
                        label={`CP Code: ${row.cp_code}`}
                    />
                )}
                <InfoItem
                    icon={<PersonIcon fontSize="small" color="action" />}
                    label={`Mobile: ${row?.mobile || "-"} · Email: ${row?.email || "-"}`}
                />
                <InfoItem
                    icon={<LocationCityIcon fontSize="small" color="action" />}
                    label={`${row?.address?.city || "-"}, ${row?.address?.state || "-"}`}
                />
                <InfoItem
                    icon={<AccountBalanceIcon fontSize="small" color="action" />}
                    label={`Bank: ${row?.bank?.bank_name || "-"} (${row?.bank?.ifsc_code || "-"})`}
                />
                <InfoItem
                    icon={<PersonIcon fontSize="small" color="action" />}
                    label={`Onboarded by: ${row?.onboarded_by?.name || "Unknown"}`}
                />
            </Grid>
        ),
        renderDetails: (row, { setSnackInfo } = {}) => (
            <>
                <Typography variant="subtitle2" style={{ fontWeight: 700, marginBottom: 12, paddingBottom: 6, borderBottom: "2px solid #edf0f7", color: "#1A3C6E" }}>Personal Details</Typography>
                <Grid container spacing={3} style={{ marginBottom: 20 }}>
                    <DetailItem icon={<PermIdentityIcon fontSize="small" color="action" />} label="CP Code" value={row?.cp_code} />
                    <DetailItem icon={<PersonIcon fontSize="small" color="action" />} label="Name" value={row?.full_name} />
                    <DetailItem icon={<PersonIcon fontSize="small" color="action" />} label="Mobile" value={row?.mobile} />
                    <DetailItem icon={<PersonIcon fontSize="small" color="action" />} label="Email" value={row?.email} md={6} />
                    <DetailItem icon={<PermIdentityIcon fontSize="small" color="action" />} label="PAN" value={row?.pan_number} />
                    <DetailItem
                        icon={<PermIdentityIcon fontSize="small" color="action" />}
                        label="Aadhaar"
                        node={
                            <AadhaarReveal
                                fetcher={() => HttpService.getChannelPartnerAadhaar(row?._id)}
                                masked={row?.aadhaar_masked || "XXXX-XXXX-XXXX"}
                                setSnackInfo={setSnackInfo}
                            />
                        }
                    />
                </Grid>

                <Typography variant="subtitle2" style={{ fontWeight: 700, marginBottom: 12, paddingBottom: 6, borderBottom: "2px solid #edf0f7", color: "#1A3C6E" }}>Address</Typography>
                <Grid container spacing={3} style={{ marginBottom: 20 }}>
                    <DetailItem icon={<LocationCityIcon fontSize="small" color="action" />} label="Address" value={row?.address?.full_address} md={12} />
                    <DetailItem icon={<LocationCityIcon fontSize="small" color="action" />} label="City" value={row?.address?.city} />
                    <DetailItem icon={<LocationCityIcon fontSize="small" color="action" />} label="State" value={row?.address?.state} />
                    <DetailItem icon={<LocationCityIcon fontSize="small" color="action" />} label="Pincode" value={row?.address?.pincode} />
                </Grid>

                <Typography variant="subtitle2" style={{ fontWeight: 700, marginBottom: 12, paddingBottom: 6, borderBottom: "2px solid #edf0f7", color: "#1A3C6E" }}>Bank Details</Typography>
                <Grid container spacing={3} style={{ marginBottom: 20 }}>
                    <DetailItem icon={<AccountBalanceIcon fontSize="small" color="action" />} label="Account Name" value={row?.bank?.account_name} md={6} />
                    <DetailItem icon={<AccountBalanceIcon fontSize="small" color="action" />} label="Bank Name" value={row?.bank?.bank_name} md={6} />
                    <DetailItem icon={<AccountBalanceIcon fontSize="small" color="action" />} label="Account No" value={row?.bank?.account_number} />
                    <DetailItem icon={<AccountBalanceIcon fontSize="small" color="action" />} label="Account Type" value={row?.bank?.account_type} />
                    <DetailItem icon={<AccountBalanceIcon fontSize="small" color="action" />} label="Branch Name" value={row?.bank?.branch_name} />
                    <DetailItem icon={<AccountBalanceIcon fontSize="small" color="action" />} label="IFSC Code" value={row?.bank?.ifsc_code} />
                </Grid>

                <Typography variant="subtitle2" style={{ fontWeight: 700, marginBottom: 12, paddingBottom: 6, borderBottom: "2px solid #edf0f7", color: "#1A3C6E" }}>Onboarding Info</Typography>
                <Grid container spacing={3}>
                    <DetailItem icon={<PersonIcon fontSize="small" color="action" />} label="Onboarded by" value={row?.onboarded_by?.name || "Unknown"} />
                    {row?.verified_by && (
                        <DetailItem
                            icon={<PersonIcon fontSize="small" color="action" />}
                            label={row?.status === "rejected" ? "Rejected by" : "Verified by"}
                            value={row.verified_by?.name}
                        />
                    )}
                    {row?.remarks && (
                        <DetailItem icon={<PersonIcon fontSize="small" color="action" />} label="Remarks" value={row.remarks} md={12} />
                    )}
                </Grid>
            </>
        ),
        documents: (row) => (
            [
                { label: "PAN Card", url: row?.pan_doc },
                { label: "Aadhaar Card", url: row?.aadhaar_doc },
                { label: "Cancelled Cheque", url: row?.cheque_doc },
            ].filter((d) => d.url)
        ),
    },
    // ── Future onboarding approval types get appended here ──
];
